export default "__VITE_ASSET__171ed515__"